export const metaInfo = {
    name: "cometchat-chat-sample-app-react",
    version: "4.3.9",
    type: "sample",
    platform: "React"
}
